jQuery(document).ready(function($) {
    $('.timeline-carousel').slick({
        infinite: false,
        slidesToShow: 2.5,
        slidesToScroll: 2,
        dots: true,
        arrows: false,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2.5,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2.15,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1.15,
                    slidesToScroll: 1
                }
            }
        ]
    });
});
